import firebase from "firebase/app";
import 'firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyAXAIZ5vxffcaM4Q6MlYgfLi9pN9SWaUFs",
  authDomain: "docklock-2e257.firebaseapp.com",
  projectId: "docklock-2e257",
  storageBucket: "docklock-2e257.firebasestorage.app",
  messagingSenderId: "794005926982",
  appId: "1:794005926982:web:cfbde61b6c0af52a0ec647",
  measurementId: "G-F1D1SN7LR8"
};


  export default  firebase.initializeApp(firebaseConfig).firestore


// WEBPACK FOOTER //
// ./src/db/index.js